import React from "react";
import _ from "lodash";
import SkeletonLoader from "UIComponents/SkeletonLoader";
import classes from "./StudentListSkeleton.scss";

const StudentListSkeleton = () => {
  return (
    <>
      <div className={classes.selectAllRow}>
        <SkeletonLoader width={80} height={20} />
        <SkeletonLoader width={20} height={20} />
      </div>
      {_.times(6, index => (
        <div key={index} className={classes.skeletonRow}>
          <SkeletonLoader variant="circular" width={40} height={40} />
          <div className={classes.skeletonText}>
            <SkeletonLoader width="60%" height={16} />
            <SkeletonLoader width="40%" height={14} />
          </div>
          <SkeletonLoader width={20} height={20} />
        </div>
      ))}
    </>
  );
};

export default StudentListSkeleton;
